import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {BntModalsComponent} from '@binotel-frontend/bnt-common-components';

@Component({
  selector: 'od-root',
  imports: [RouterOutlet, BntModalsComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
